// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"39948a3d","286":"41fd7165"}[chunkId] + ".chunk.css";
};